<template>
<div>

    <div class="score">
        <div class="wrapper">

            <div class="score__title">
                {{ post_title }}
            </div>

            <div class="player-filter">

                <div class="player-filter__switch">
                    <ul>
                        <li>
                            <a @click.prevent="type = 'atp'"
                               :class="{ active: type == 'atp' }"
                               href="#">
                                <span>atp</span>
                            </a>
                        </li>
                        <li>
                            <a @click.prevent="type = 'wta'"
                               :class="{ active: type == 'wta' }"
                               href="#">
                                <span>wta</span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="player-filter__type">
                    <select v-model="selectedDay"
                            id="s2daySelector"
                            name="s2daySelector">
                        <!--<option :value="event" v-for="event in possibleEvents">{{event}}</option>-->
                    </select>
                </div>

            </div>

        </div>
    </div>

    <div class="wrapper wrapper--scoring">

        <div class="Results-matches">

            <score-card v-if="showMatch(match)"
                        v-for="match in matches"
                        :match="match"
                        :flagPath="flagPath"
                        :key="match.id"
                        mode="result"
                        :type="type"
                        :detail="detail"
                        :data-id="match.id">
            </score-card>

            <div class="na">
                <div class="na__info" v-html="ico_info"></div>

                <div class="na__title" style="margin-bottom: 0">
                    No results for this day
                </div>
            </div>

        </div>

    </div>

</div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import 'select2/dist/js/select2.full.js'

    import MatchCard from './MatchCard.vue'

    export default {
        props: [ 'pretype', 'flag', 'detail', 'tournament', 'post_title' ],
        components: {
            'score-card': MatchCard
        },
        data() {
            return {
                feed            : '',
                allMatches      : [],
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                matches         : [],
                type            : '',
                days            : [],
                selectedDay     : '1',
                tournament_slug : this.tournament,
                ico_info        : window.ico_info,
            }
        },
        created() {
            this.type = this.pretype
            this.getFeed()
        },
        mounted() {
            let vm = this
            jQuery('#s2daySelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedDay = this.value
            })
        },
        computed: {
            // possibleEvents() {
            //     return this.getPossibleEvents()
            // }
        },
        watch: {
            type() {
                this.getFeed()
            },
            selectedDay(newValue, oldValue) {
                this.matches = this.getDateSeqMatches(newValue, this.allMatches)
            }
        },
        methods: {
            getAllMatchesInOneArray(feed) {
                let allMatches = []

                for (let event of feed) {
                    for (let round of event.rounds) {
                        allMatches.push(...round.matches)
                    }
                }

                return allMatches
            },
            getOnlyFinishedMatches(matches) {
                return matches.filter(function (match) {

                    return match.detail.state == 'F'

                })

            },
            getDateSeqMatches(dateSeq, matches) {
                return matches.filter(function (match) {
                    return match.detail.dateSeq == dateSeq
                })
            },
            getFeed() {
                this.getDraws()
                this.getOOPDays()
            },
            showMatch(match) {
                if (!match.detail) {
                    return false
                }

                if (match.detail.state == 'F') {
                    return true
                }
            },
            getOOPDays() {
                let app = this

                axios.get(`${window.feed_ip}/get/${this.type}/${this.tournament_slug}/oop`).then(response => {

                    let feed = response.data
                    let seq = 0

                    if (response.data.length > 0) {
                        seq = parseInt(response.data[0].seq)
                    }

                    let days = feed.map(day => {
                        return day.date
                    })
                    this.days = days

                    let seqDay = days.length - 1 + seq

                    //for some reason it couldn't select the last day of WTA; consider removing this if there are issues
                    // if ( this.type == 'wta' )
                    //     seqDay = seqDay + 1

                    let currentSeqMatches = this.getDateSeqMatches(seqDay, this.allMatches)

                    if (currentSeqMatches.length == 0) {
                        this.selectedDay = seqDay - 1
                    } else {
                        this.selectedDay = seqDay
                    }

                    jQuery('#s2daySelector').empty().select2({
                        width: '100%',
                        data: days.map(function (day, index) {
                            return {
                                id: index + seq,
                                text: `day ${index + seq} - ` + app.formatDate(day)
                            }
                        })
                    }).val(this.selectedDay).trigger('change')

                }).catch(function (error) {
                    console.log(error)
                })
            },
            formatDate(day) {
                return moment(day).format('MMMM DD')
            },
            getDraws() {
                axios.get(`${window.feed_ip}/get/${this.type}/${this.tournament_slug}/draws`).then(response => {
                    this.feed = response.data

                    let allMatches = this.getAllMatchesInOneArray(response.data)
                    let finishedMatches = this.getOnlyFinishedMatches(allMatches)

                    this.allMatches = finishedMatches

                    this.allMatches.sort( function(a, b) {

                        let matchDateA = moment(a.detail.ts).format()
                        let matchDateB = moment(b.detail.ts).format()

                        if ( moment( matchDateA ).isAfter( matchDateB ) )
                            return -1
                        else if ( moment( matchDateA ).isBefore( matchDateB ) )
                            return 1
                        else if ( moment( matchDateA ).isSame( matchDateB ) )
                            return 0
                    })

                    this.matches = this.getDateSeqMatches(this.selectedDay, this.allMatches)

                }).catch(function (error) {
                    console.log(error)
                })
            }
        }
    }
</script>
